import React, { Component } from 'react'
import ReactMarkdown from "react-markdown"
import { connect } from 'react-redux';
import {Link} from 'gatsby'


class PodGrid extends Component {
  constructor(props) {
    super(props)


    this.layoutContents = React.createRef()
  }

  render() {




return(


      <li className="slice__item list__item row__item row__item--span-1">



          <div className="item itemEnlarge">
              <div style={{backgroundColor:this.props.data.TileBackgroundColor ,borderColor:this.props.data.TileBordercolor}} className="item__container podcast">
                  <div className="item__media">

                  </div>
                  <div className="item__content ">
                      <div className="item__header" style={{color:this.props.data.TileTextColor}}>
                          <h3 className="item__title" style={{color:this.props.data.TileTextColor}}>
                          {this.props.data.title}
                          </h3>
                      </div>
                      <div className="item__teaser">
                        <div className="ButtonBlack">Listen</div>
                      </div>
                  </div>


                  <Link className="block-link-overlay"
                    to={`/podcasts/${this.props.data.slug}`}
                  />
    </div>
              </div>

      </li>

    )


}
}


function mapStateToProps(state) {
  return {
    pods: state.pods
  };
}

export default connect(mapStateToProps)(PodGrid);
